/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'edit-icon': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M11.67 6.686a.625.625 0 011.25 0v5.608a.62.62 0 01-.625.625H1.705a.62.62 0 01-.625-.625V1.704c0-.352.286-.625.624-.625h5.621c.338 0 .612.286.612.624a.633.633 0 01-.625.625H2.33v9.342h9.342V6.686zM5.635 9.12a.605.605 0 01-.872 0 .62.62 0 010-.885l6.805-6.805a.605.605 0 01.872 0 .62.62 0 010 .885L5.634 9.12z" _fill="#787878"/>'
  }
})
